import { Failure } from '../../entities/Failure';
import { Success } from '../../entities/Success';
import api from '../api';

export async function createLoyaltyProgram(formData) {
  try {
    const { data } = await api.post('/loyalty/program', formData);

    return new Success(data);
  } catch (error) {
    console.log(error);
    return new Failure();
  }
}
